import { useSettings } from "@/lib/settings";
import { MessageCircle } from "lucide-react";

export const buildWhatsAppLink = (number, message, vehicleName) => {
  const msg = (message || "Hello, I am interested in financing the [VEHICLE NAME].").replace(
    "[VEHICLE NAME]", vehicleName || "a vehicle"
  );
  const num = (number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${num}?text=${encodeURIComponent(msg)}`;
};

export const WhatsAppButton = ({ vehicleName }) => {
  const settings = useSettings();
  if (!settings) return null;
  const link = buildWhatsAppLink(settings.whatsapp_number, settings.whatsapp_message, vehicleName);
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-cta"
      aria-label="Chat with F&L Cars on WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full bg-[#25D366] px-5 py-4 text-white shadow-[0_8px_30px_rgba(37,211,102,0.4)] transition-transform hover:scale-105 group"
    >
      <MessageCircle className="h-6 w-6" fill="white" />
      <span className="hidden sm:block max-w-0 overflow-hidden whitespace-nowrap text-sm font-semibold transition-all duration-300 group-hover:max-w-[220px]">
        Chat with F&L Cars on WhatsApp
      </span>
    </a>
  );
};
